// extracted by mini-css-extract-plugin
export default {"header":"header--fL6T8","menuWrapper":"menuWrapper--_QBte"};